module.exports = __webpack_public_path__ + "img/getprize_btn_img.d6c95784.png";